import React, { useState, useEffect } from 'react';
import './App.css';
import Cazare from './Cazare';
import Locatie from './Locatie';
import Contact from './Contact';
import { useLanguage } from './LanguageContext';

function App() {
  const { language, setLanguage, t } = useLanguage();
  const [index, setIndex] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false); 
  const [currentPage, setCurrentPage] = useState('home'); 

  const slides = [
    { image: '/images/fatada.jpeg', text: t('slide_1') },
    { image: '/images/livada1.jpeg', text: t('slide_2') },
    { image: '/images/mere.jpeg', text: t('slide_3') },
    { image: '/images/livada2.jpeg', text: t('slide_4') },
    { image: '/images/satul.jpeg', text: t('slide_5') },
    { image: '/images/spate1.jpeg', text: t('slide_6') },
    { image: '/images/cetatea.jpeg', text: t('slide_7') },
    { image: '/images/spate2.jpeg', text: t('slide_8') },
    { image: '/images/campuri.jpeg', text: t('slide_9') },
  ];

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const goToPage = (page, event) => {
    event.preventDefault();
    setCurrentPage(page);
    setMenuOpen(false);
  };

  const prevSlide = () => setIndex((idx) => (idx - 1 + slides.length) % slides.length);
  const nextSlide = () => setIndex((idx) => (idx + 1) % slides.length);

  useEffect(() => {
    if (currentPage !== 'home') return;

    const timer = setInterval(() => {
      setIndex((idx) => (idx + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [index, currentPage, slides.length]);

  return (
    <div className="App-wrapper">
      
      {/* BUTOANE LIMBI (SUS STÂNGA) */}
      <div className="language-switcher">
        <button className={`lang-btn ${language === 'ro' ? 'active' : ''}`} onClick={() => setLanguage('ro')}>RO</button>
        <button className={`lang-btn ${language === 'en' ? 'active' : ''}`} onClick={() => setLanguage('en')}>EN</button>
        <button className={`lang-btn ${language === 'de' ? 'active' : ''}`} onClick={() => setLanguage('de')}>DE</button>
      </div>
      
      {/* MENIU HAMBURGER (SUS DREAPTA) */}
      <div className={`menu-wrapper ${menuOpen ? 'active' : ''}`}>
        <button className="hamburger-btn" onClick={toggleMenu}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </button>
        
        <nav className="dropdown-menu">
          <a href="#home" onClick={(e) => goToPage('home', e)}>{t('menu_home')}</a>
          <a href="#cazare" onClick={(e) => goToPage('cazare', e)}>{t('menu_cazare')}</a>
          <a href="#locatie" onClick={(e) => goToPage('locatie', e)}>{t('menu_locatie')}</a>
          <a href="#contact" onClick={(e) => goToPage('contact', e)}>{t('menu_contact')}</a>
        </nav>
      </div>

      {/* RENDERIZARE CONDIȚIONALĂ */}
      {currentPage === 'home' && (
        <div className="slideshow-container">
          {slides.map((slide, i) => (
            <div
              key={i}
              className={`slide ${i === index ? 'active' : ''}`}
              style={{ backgroundImage: `url(${slide.image})` }}
            >
              <div className="overlay-content">
                <h1>{slide.text}</h1>
              </div>
            </div>
          ))}

          <button className="nav-btn prev" onClick={prevSlide}>&#10094;</button>
          <button className="nav-btn next" onClick={nextSlide}>&#10095;</button>
        </div>
      )}

      {currentPage === 'cazare' && <Cazare />}
      {currentPage === 'locatie' && <Locatie />}
      {currentPage === 'contact' && <Contact />}

    </div>
  );
}

export default App;